import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { ProductService, ViewTransitionStateService } from '@frontend/vanilla/core';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

export class ViewTransitionProductSwitchDetectionService {
    readonly #router = inject(Router);
    readonly #productService = inject(ProductService);
    readonly #viewTransitionStateService = inject(ViewTransitionStateService);

    init(): void {
        this.initializeProductNavigationDetection();
    }

    private initializeProductNavigationDetection(): void {
        this.#router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
            this.#viewTransitionStateService.setIsProductSwitch(false);
        });

        this.#productService.productChanged
            .pipe(
                map((product) => product.name),
                distinctUntilChanged(),
            )
            .subscribe(() => {
                this.#viewTransitionStateService.setIsProductSwitch(true);
            });
    }
}

export const provideProductSwitchDetection = (): (EnvironmentProviders | Provider)[] => {
    return [ViewTransitionProductSwitchDetectionService, provideAppInitializer(productSwitchDetectionInitializer)];
};

const productSwitchDetectionInitializer = (): void => {
    inject(ViewTransitionProductSwitchDetectionService).init();
};
